import React, { useState, useEffect } from "react";
import { Box, Grid, TextField, MenuItem, Button } from "@mui/material";
import { getUserDetails, updateUserProfile } from "../../services/userService";
import { useNotification } from '../../context/NotificationContext';

function ProfileUpdate() {
    const { showNotification } = useNotification();
    const [profile, setProfile] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        linkedInProfile: "",
        gender: "other",
    });

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const userData = await getUserDetails();
                setProfile(userData);
            } catch (error) {
                // console.error("Failed to load profile:", error);
                showNotification("Failed to load profile", "error");
            }
        };
        fetchUserDetails();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        try {
            await updateUserProfile(profile);
            showNotification("Profile updated successfully!", "success");
        } catch (error) {
            if (error.response?.data?.errors?.length) {
                // Extract the first error message from the errors array
                showNotification(error.response.data.errors[0].msg, "error");
            } else {
                showNotification("Failed to update profile. Please try again.", "error");
            }
        }
    };

    return (
        <Box>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="First Name"
                        variant="outlined"
                        size="medium"
                        name="firstName"
                        value={profile.firstName}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Last Name"
                        variant="outlined"
                        size="medium"
                        name="lastName"
                        value={profile.lastName}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Email Address"
                        variant="outlined"
                        size="medium"
                        value={profile.email}
                        InputProps={{ readOnly: true }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Gender"
                        variant="outlined"
                        size="medium"
                        select
                        name="gender"
                        value={profile.gender}
                        onChange={handleChange}
                    >
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Phone Number"
                        variant="outlined"
                        size="medium"
                        name="phoneNumber"
                        value={profile.phoneNumber}
                        onChange={handleChange}
                        helperText="Example: 2348012345678"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="LinkedIn Profile"
                        variant="outlined"
                        size="medium"
                        name="linkedInProfile"
                        helperText="Example: linkedin.com/in/john-doe"
                        value={profile.linkedInProfile}
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>
            <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ marginTop: "2rem", textTransform: "none" }}
                onClick={handleSubmit}
            >
                Update Profile
            </Button>
        </Box>
    );
}

export default ProfileUpdate;
